import React from 'react';
import { useField } from '@unform/core';
import { useLocation } from 'react-router-dom';

export default function useFormType(name, type = 'value') {
  const ref = React.useRef(null);
  const location = useLocation();
  const { fieldName, registerField, defaultValue, error } = useField(name);

  React.useEffect(() => {
    registerField({
      name: fieldName,
      ref: ref?.current,
      path: type,
      getValue: ({ value }) => {
        return type === 'value'
          ? !isNaN(value) && value !== ''
            ? +value
            : value
          : ref?.current.checked;
      },
    });
  }, [type, fieldName, registerField, location]);

  return { fieldName, defaultValue, error, ref, location };
}
